<div class="section-wrapper" style="padding: 1em;">
    @if (show) {
    <cx-datagrid (onPageChange)="onPageChange($event)" (onPageSizeChange)="onPageSizeChange($event)"
        [pagingConfig]="pagingConfig" [title]="title" [module]="module" [fieldmodule]="fieldmodule"
        (search)="onSearch($event)" [showExport]="isShowExport" (export)="onExport($event)" (filter)="onFilter($event)"
        [inputPlaceholder]="datagridPlaceholder" (changeViews)="onViewsChange($event)"
        (createView)="onCreateView($event)" [columns]="columns" [rows]="records | paginate: pagingConfig" (save)="onGridSettingSave($event)"
        [moreOptions]="moreOptions">
        <ng-template tTemplate="nodata">
            <div class="cx-datagrid-no-data">
                <div colspan="100%" align="center">
                    <i class="no-data__icon fa-light fa-chart-simple"></i>
                    No recent data at the moment
                </div>
            </div>
        </ng-template>
        <ng-template tTemplate="header" let-ctx="ctx">
            <tr>
                <ng-container *ngFor="let column of ctx.columns; let index = index;">
                    <th class="table-center" style="width: 50px;" *ngIf="column.selection" [cxColumnFrozen]="column">
                        <input [isSelectAll]="true" [cxSelectionColumn]="column" [checked]="column.selected"
                            type="checkbox" class="hand" />
                    </th>
                    <th *ngIf="!column.selection" [cxColumnSort]="column" (sort)="onSort($event)"
                        [cxColumnFrozen]="column"
                        [class.column-sorted]="column.key === sortColumn.key">
                        <div class="header-info">
                            <div>{{ column.name }}</div>
                            <i *ngIf="column.sortable" class="sort-icon fa-solid fa-arrow-up-wide-short"
                                [ngClass]="{ 'fa-arrow-down-wide-short': !column.order, 'fa-arrow-up-wide-short': column.order }"></i>
                        </div>

                        <div cxColumnResize [gridMode]="ctx.gridMode" [columnsLength]="ctx.columns"
                            [cxColumnResizeIndex]="index" class="resizer"></div>
                    </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template tTemplate="body" let-ctx="ctx">
            <tr (clickOutside)="ctx.row.show = false">
                <ng-container *ngFor="let column of ctx.columns; let index = index;">
                    <td *ngIf="!column.selection" [cxColumnFrozen]="column">
                        <span *ngIf="!column.clickable && column.key !== 'note'">{{ ctx.row | cxnestedread:column
                            }}</span>
                        <!-- note -->
                        <span *ngIf="column.key === 'note'" [attr.data-tooltip]="ctx.row[column.key]"
                            data-tooltip-conf="bottom multiline">
                            {{ ctx.row.note | cxsplice:0:50 }}
                        </span>
                        <!-- <ng-container *ngIf="column.clickable && column.key == 'Duration'">
                                <span *ngIf="!column.clickable">{{ ctx.row['Duration'] }}</span>
                              </ng-container> -->
                        <ng-container *ngIf="column.clickable && reportType == 'AssignLeads'">
                            <span data-tooltip="Callback"
                                [attr.data-tooltip-conf]="records.length == index + 1 ? 'top' : 'bottom'">
                                <i [ngClass]="{'disabled' : callIndex == index && !callEnabled }"
                                    class="fa-solid fa-phone call-status-icon" (click)="onDialCall(ctx, index)"></i>
                                <!-- <i class="fa-regular fa-ellipsis-vertical"></i> -->
                            </span>
                        </ng-container>
                        <ng-container *ngIf="column.clickable && (reportType == 'Callback' || reportType == 'CallLogs')">
                            <div class="dropdown">
                                <span data-tooltip="Callback" class="callBtn"
                                    [attr.data-tooltip-conf]="records.length == index + 1 ? 'top' : 'bottom'">
                                    <i [ngClass]="{'disabled' : callIndex == index && !callEnabled }"
                                        class="fa-solid fa-phone call-status-icon has-sub-icon" (click)="toggleDropdown(ctx)">
                                        <i class="fa-solid fa-angle-down sub-icon green"></i>
                                    </i>
                        
                                    <!-- <i class="fa-regular fa-ellipsis-vertical"></i> -->
                                </span>
                                <div class="dropdown-content" [ngClass]="{'show': ctx.row.show }">
                                    <a href="javascript:void(0);" (click)="onCallbackDial(ctx, index, 'primary')"><i
                                            class="fa-solid fa-phone fa-fw"></i> Primary Number</a>
                                    <a href="javascript:void(0);" (click)="onCallbackDial(ctx, index, 'callback')"><i
                                            class="fa-solid fa-phone fa-fw"></i> Callback Number</a>
                                </div>
                            </div>
                        </ng-container>

                        <span *ngIf="column.editable" [cxEditColumn]="column" [cxEditColumnRow]="ctx.row[column.key]"
                            class="edit">
                            <i class="fa fa-edit"></i>
                            <!-- <fa-icon [icon]="Icons.faEdit" /> -->
                        </span>
                    </td>
                    <td class="table-center" style="width: 50px;" *ngIf="column.selection" [cxColumnFrozen]="column">
                        <input [(ngModel)]="ctx.row.selected" [checked]="column.selected || ctx.row.selected"
                            class="hand" [cxSelectionColumn]="column" [cxSelectionColumnRow]="ctx.row"
                            type="checkbox" />
                    </td>
                </ng-container>
            </tr>
        </ng-template>
    </cx-datagrid>
    }
</div>